module.exports = __webpack_public_path__ + "img/PreSchoolMonkey.98e0934a.svg";